module.exports = __webpack_public_path__ + "static/media/kiosk_bg.1a6fdb78.png";